import { escapeAttr, escapeHtml } from "@emkit/builder-core";
import { looksLikeHtml, sanitizeRichHtml } from "./sanitize.js";
export const ACCORDION_DEFAULTS = {
    items: [
        {
            id: "a1",
            title: "What is EmBuilder?",
            body: "A visual page builder for EmDash that compiles to clean static HTML.",
        },
        {
            id: "a2",
            title: "Does it require a runtime?",
            body: "No JavaScript is emitted for most widgets — pages work without JS.",
        },
        {
            id: "a3",
            title: "Can I import my design later?",
            body: "Yes — Export JSON and Import JSON round-trip is lossless.",
        },
    ],
    exclusive: true,
    defaultOpenFirst: false,
};
export const accordionWidget = {
    type: "accordion",
    defaultProps: ACCORDION_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-accordion" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty accordion — add items in the inspector)</div>`;
        }
        // A stable per-render group name makes multiple accordions on the
        // same page independent without requiring user config.
        const groupName = `acc-${Math.random().toString(36).slice(2, 8)}`;
        const nameAttr = props.exclusive ? ` name="${escapeAttr(groupName)}"` : "";
        const rows = items
            .map((item, i) => {
            const open = props.defaultOpenFirst && i === 0 ? " open" : "";
            const body = looksLikeHtml(item.body)
                ? sanitizeRichHtml(item.body)
                : `<p>${escapeHtml(item.body).replace(/\n/g, "<br>")}</p>`;
            return `<details class="emk-accordion-item"${nameAttr}${open} style="border-bottom:1px solid #e5e7eb">
  <summary style="list-style:none;cursor:pointer;padding:14px 16px;font-weight:500;display:flex;justify-content:space-between;align-items:center;gap:12px">
    <span>${escapeHtml(item.title)}</span>
    <span class="emk-accordion-chev" aria-hidden="true" style="transition:transform 0.2s;color:#6b7280">▾</span>
  </summary>
  <div class="emk-accordion-body" style="padding:0 16px 14px;color:#374151;line-height:1.6">${body}</div>
</details>`;
        })
            .join("");
        return `<div class="emk-accordion" style="border-top:1px solid #e5e7eb">${rows}</div>`;
    },
};
//# sourceMappingURL=accordion.js.map